/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'

import { useDropdownContext } from '../DropdownContext/useDropdownContext'
import { MenuList } from '../../MenuList'

import { ItemProps } from './Item.types'

export const Item = ({
  children,
  index,
  icon,
  role,
  onClick,
  onKeyDown,
}: ItemProps) => {
  const dropdownContext = useDropdownContext()

  return (
    <MenuList.Item
      data-option-index={index}
      data-focus={dropdownContext.focusedIndex === index}
      role={role || 'menuitem'}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {icon}
      {children}
    </MenuList.Item>
  )
}
